
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { interpreterName } from "helpers/interpreterName";
import Api from "services/api"
import toast from "react-hot-toast";
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { userSelector } from "slices/userSlice";
import { usePermissions } from "layouts/Admin";
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import { paymentSelector } from "slices/paymentSlice";
import ConfirmationStatus from "components/common/ConfirmationMessageStatus";
import { handleMultipleStatus } from "slices/paymentSlice";
import { fetchInterpreterPayments } from "slices/paymentSlice";
import PaymentSideModal from "components/payments/PaymentSideModal";
import { Button } from "@mui/material";
import { setInterpreterPayments, downloadFullPaymentReport } from "slices/paymentSlice";
import { CheckinCheckoutAdjustmentModal } from "components/appointment/checkinCheckoutAdjustment";
import { Link } from "react-router-dom";
import { setActionAssign } from "slices/actionButtonSlice";
import { fetchAppointmentView } from "slices/appointmentSlice";
import { getBackgroundStyle } from "components/common/TableColor";
import Swal from "sweetalert2";
const apiService = new Api();

function IntepreterPayments() {
    const dispatch = useDispatch()
    const { checkPermission } = usePermissions();
    const { generatedInvoices } = useSelector(paymentSelector);

    const [payment, setPayment] = useState([])
    const [totalPages, settotalPages] = useState(0)
    const [loader, setloader] = useState(false)
    const [loading, setLoading] = useState(false)
    const [current_page, setcurrentPage] = useState(1)
    const [pageLength, setpageLength] = useState(10)
    const [total, settotal] = useState(10)
    const [statusModal, setStatusModal] = React.useState(false);
    const refAddutton = React.useRef(null);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [paymentDetail, setPaymentDetail] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'name',
        sortDirection: 'asc',
    });
    const { user } = useSelector(userSelector);
    const userToken = user.token;
    const [item, setItem] = React.useState({});
    const [filterDates, setFilterDates] = React.useState({
        start_date: "",
        end_date: "",
    });



    // No initial API call; data will be fetched only when a filter/search is performed.

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false);
            setloader(true);
            dispatch(fetchInterpreterPayments("", "", "", "", (res) => {
                setPayment(res.data);
                settotalPages(res.last_page);
                setcurrentPage(res.current_page);
                setpageLength(res.per_page);
                settotal(res.total);
                setInterpreterPayments(res.data);
                setloader(false);
            }))
            hideConfirmStatusDialog()
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };


    const fetchInterpreterPaymentsWrapper = (page, params = {}, disableLoader = false) => async (dispatch) => {
    const callback = (res) => {
        if (res) {
            setPayment(res.data);
            settotalPages(res.last_page);
            setcurrentPage(res.current_page);
            setpageLength(res.per_page);
            settotal(res.total);
            setInterpreterPayments(res.data);
            setloader(false);
        }
    };

    const payload = {
        ...params,
        pageLength: Number(params.pageLength || pageLength),
        page: page || current_page
    };

    return dispatch(fetchInterpreterPayments(page || current_page, payload, disableLoader, false, callback));
};


    const hideConfirmStatusDialog = () => {
        setStatusModal(false);
    }
    const showConfirmStatusDialog = () => {
        setStatusModal(true);
        return
    };
    const handleStatusChangeItems = () => {
        dispatch(handleMultipleStatus({ ids: selectedItems }, submitCallback))
    }

    const handleChange = (e) => {
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };
    const handleToggleSelectAll = () => {
        if (selectAll) {
            setSelectedItems([])
            setSelectAll(false)
            return
        }
        setSelectAll(true)
        setSelectedItems(payment?.map((val) => val.id.toString()))
    }

    // Filter/search handlers for InvoicePayments
    const handleFilter = (data) => {
        setloader(true);
        dispatch(fetchInterpreterPayments(1, data, false, false, (res) => {
            setPayment(res.data);
            settotalPages(res.last_page);
            setcurrentPage(res.current_page);
            setpageLength(res.per_page);
            settotal(res.total);
            setInterpreterPayments(res.data);
            setloader(false);
        }));
    };
    const handleReset = (defaultValues) => {
        setloader(true);
        setFilterDates('')
        dispatch(fetchInterpreterPayments(1, defaultValues, false, false, (res) => {
            setPayment(res.data);
            settotalPages(res.last_page);
            setcurrentPage(res.current_page);
            setpageLength(res.per_page);
            settotal(res.total);
            setInterpreterPayments(res.data);
            setloader(false);
        }));
    };

    // ...existing code...
    const renderTableHeader = React.useCallback(() => {
        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchInterpreterPayments("", "", "", "", (res) => {
                setPayment(res.data);
                settotalPages(res.last_page);
                setcurrentPage(res.current_page);
                setpageLength(res.per_page);
                settotal(res.total);
                setInterpreterPayments(res.data);
                setloader(false);
            }))
        }
        return (
            <tr>
                <th className="col-1">
                    <div className="row_check">
                        <span>#</span>
                    </div>
                </th>
                <th>
                    <TableHeaderItem
                        title="Job"
                        sortBy="interpreter_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Interpreter"
                        sortBy="appt_no"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>Vendor Site Code</th>
                <th>
                    <TableHeaderItem
                        title="Hours"
                        sortBy="payment"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Hourly Rate"
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Weekend/Holiday"
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Travel Fee"
                        sortBy="travel_fee"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Total"
                        sortBy="total_amount"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="status"
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Updated At"
                        sortBy="updated_at"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
            {checkPermission("Adjust Billing") && (
                <th>
                    <TableHeaderItem
                        title="Action"
                        callBack={callBack}
                    />
                </th>
            )}
            </tr>
        )
    }, [selectAll, searchTerm, sortConfig, current_page, selectedItems]);

    const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);
    // ...existing code...
    const renderTableContent = React.useCallback(() => {
        return (
            <>

                {
                }
                {payment?.map((item, index) => (
                    <PaymentItems item={item} setItem={setItem} invoice={generatedInvoices} data={item} userToken={userToken} index={index} selectedItems={selectedItems} setPaymentDetail={setPaymentDetail}  handleChange={handleChange} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
                ))}
            </>
        )
    }, [payment, selectedItems]);


    const callViewApi = async () => {
        handleFilter(filterDates);
        
    };
    const handleCloseCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(false);
    };
    const handleSubmit = (data, end_point, callBack) => {
        setLoading(true);
        console.log("data", data)
        const submitCallback = (success, message) => {
            callBack && callBack();
            if (success) {
                handleCloseCheckinCheckoutModal();
                callViewApi();
                toast.success(message, {
                    className: "successToast",
                });
                setLoading(false);
                // scheduleDetailModal?.show && openModal()
            } else {
                toast.error(message, {
                    className: "errorToast",
                });
                setLoading(false);
            }
        };
        dispatch(setActionAssign(data.id, data, end_point, submitCallback));
    };
    // ...existing code...
    return (
        <>

            <CheckinCheckoutAdjustmentModal
                isOpen={checkinCheckoutModal}
                handleClose={handleCloseCheckinCheckoutModal}
                onConfirm={handleSubmit}
                onSubmit={handleSubmit}
                item={item}
                loader={loading}
            />
            <InvoicePayments onFilter={handleFilter} onReset={handleReset} setFilterDates={setFilterDates}/>
            <ListLayout
                time={false}
                addButtonDisabled={true}
                // buttonTitle='downlaod all record'
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                hideRemoveButton={true}
                paymentButton={true}
                totalPages={totalPages}
                fetchList={fetchInterpreterPaymentsWrapper}
                selectedItems={selectedItems}
                refAddutton={refAddutton}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                showConfirmDialog={showConfirmStatusDialog}
                loader={loader}
                noOfItems={total}
                containerStyle={{ marginTop: '0' }}
                searchPlaceholder="Search..."
                paginationParams={filterDates}
            >
                {statusModal && <ConfirmationStatus onClose={hideConfirmStatusDialog} isOpen={statusModal} onConfirm={handleStatusChangeItems} />}
            </ListLayout>

            <PaymentSideModal data={paymentDetail} />

        </>

    )
}


const PaymentItems = ({
    data, index, current_page, pageLength, handleChange, setPaymentDetail, selectedItems, checkPermission, setItem, item
}) => {
    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);

    const dispatch = useDispatch();
    const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);

    const handleCloseCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(false);
    };

    const handleOpenCheckinCheckoutModal = (itemData) => {
        // console.log('shery', itemData);
        setCheckinCheckoutModal(true);
        setItem({ id: itemData?.id , details: itemData , travel_fee: itemData?.appointment_details?.travel_fee_amount , travel_approved : itemData?.appointment_details?.travel_approved , adjust_modal : true });
    };






    return (
        <>
            <tr>
                <td style={getBackgroundStyle(data?.status)}>
                    <div className="row_check">
                        <span>{serial}</span>
                    </div>
                </td>

                <td style={getBackgroundStyle(data?.status)}>
                    {checkPermission('Detail Billing') ? 
                    <Link
                        className="link_preview"
                        target="_blank"
                        to={`/appointments/view/${data?.id}`}
                    >
                        {data?.appid}
                    </Link> : data?.appid }
                </td>
                <td style={getBackgroundStyle(data?.status)}>
                    {interpreterName(data?.interpreter)}
                </td>
                <td style={getBackgroundStyle(data?.status)}>
                    {data?.interpreter?.vendor_site_code === 'Paper Check'
                        ? (data?.interpreter?.paper_check_payee || 'Paper Check')
                        : (data?.interpreter?.vendor_site_code || '-')}
                </td>
                <td style={getBackgroundStyle(data?.status)}>
                    {data?.interpreter_payment?.duration}
                </td>
                <td style={getBackgroundStyle(data?.status)}>
                    ${data?.interpreter_payment?.rate}
                </td>
                <td style={getBackgroundStyle(data?.status)}>
                    ${data?.interpreter_payment?.weekend_holiday}
                </td>
                <td style={getBackgroundStyle(data?.status)}>
                    ${data?.interpreter_payment?.travel_fee}
                </td>
                <td style={getBackgroundStyle(data?.status)}>
                    ${data?.interpreter_payment?.total_amount}
                </td>
                <td style={getBackgroundStyle(data?.status)} className="text-capitalize">
                    {data?.status || 'N/A'}
                </td>
                <td style={getBackgroundStyle(data?.status)} className="text-capitalize">
                    {data?.date || 'N/A'}
                </td>
                {checkPermission("Adjust Billing") && (
                <td style={getBackgroundStyle(data?.status)}>
                    <button
                        type="button"
                        className="main_button"
                        btnText="Adjust"
                        data-bs-toggle="modal"
                        data-bs-target="#checkinCheckoutAdjustmentModal"
                        onClick={() => handleOpenCheckinCheckoutModal(data)}
                    >Adjust</button>
                </td>)}
            </tr>
        </>
    )
}


export default IntepreterPayments;





const InvoicePayments = ({ onFilter, onReset , setFilterDates }) => {
    const startDateRef = React.useRef(null);
    const endDateRef = React.useRef(null);
    const dispatch = useDispatch()
    const [loader, setLoader] = useState(false);

    const defaultValues = {
        start_date: "",
        end_date: "",
        vendor_site_code: "",
    };
    const { handleSubmit, control, reset, getValues } = useForm({
        defaultValues: defaultValues
    });

    useEffect(() => {
        // setFilterDates(defaultValues)
    },[defaultValues])

    const handleResetFields = () => {
        reset(defaultValues);
        onReset(defaultValues);
    };

    const onSubmit = (data) => {
        onFilter(data);
        setFilterDates(data);
    };
    // const params = {
    //     start_date: startDateRef,
    //     end_date: endDateRef,
    // };
    const handleDownloadReport = (data) => {
        //  console.log(getValues());
        // new Swal({
        //     title: "Are you sure?",
        //     text: "You want to invite these interpreters?",
        //     icon: "warning",
        //     showCancelButton: true,
        //     confirmButtonColor: "#3085d6",
        //     cancelButtonColor: "#d33",
        //     confirmButtonText: "Yes"
        // }).then(result => {
        //     if (result.isConfirmed) {
        //         dispatch(addInviteInterpreters({ interpreter_ids: selectedItems, }, itemId, submitCallback))
        //     }
        // })
        setLoader(true);
        dispatch(downloadFullPaymentReport(getValues(), (success, message) => {
            setLoader(false);
            if (success) {
                Swal.fire({
                    title: "Success!",
                    text: message || "Report downloaded successfully",
                    icon: "success",
                    confirmButtonColor: "#3085d6",
                    }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                });
            } else {
                Swal.fire({
                    title: "Error!",
                    text: message || "Failed to download report",
                    icon: "error",
                    confirmButtonColor: "#d33",
                });
            }
        }));
    };
    // const handleDownloadReport = () => {
    //     setLoader(true);
    //     dispatch(downloadFullPaymentReport(getValues(), (success, message) => {
    //         setLoader(false);
    //         if (success) {
    //         Swal.fire({
    //             title: "Success!",
    //             text: message || "Report downloaded successfully",
    //             icon: "success",
    //             confirmButtonColor: "#3085d6",
    //         }).then((result) => {
    //             if (result.isConfirmed) {
    //             // optional: reload or other action
    //             window.location.reload();
    //             }
    //         });
    //         } else {
    //         Swal.fire({
    //             title: "Error!",
    //             text: message || "Failed to download report",
    //             icon: "error",
    //             confirmButtonColor: "#d33",
    //         });
    //         }
    //     }));
    //     };
    const { checkPermission } = usePermissions();

    return (
        <div className="content" style={{ minHeight: 'auto' }}>
            {loader && (
            <div className="global-loader">
                <div className="customSpinner"></div>
            </div>
            )} 
            <div className="row_main_head">
                <h2 className={`main_heading`}>Billing</h2>
            </div>
            <div className="card_table">
                <form className="invoicing_form" onSubmit={handleSubmit(onSubmit)}>
                    <div className='billings row_Invoice'>
                        <div className="row-primary">
                            <h2>From Date</h2>
                            <Controller
                                // rules={{ required: "From date is required" }}
                                name="start_date"
                                control={control}
                                render={({ field }) => (
                                    <div className="input-image">
                                        <input ref={startDateRef} id='start_date' type="date" name='start_date' placeholder='Start Date' required
                                            {...field}
                                            value={field.value}
                                            onChange={(e) => field.onChange(moment(e.target.value).format("YYYY-MM-DD"))}
                                        />
                                        <img src="/images/celender.png" alt="calendar Icon" className="custom-icon" />
                                    </div>
                                )} />
                        </div>
                        <div className="row-primary">
                            <h2>To Date</h2>
                            <Controller
                                rules={{ required: "To date is required" }}
                                name="end_date"
                                control={control}
                                render={({ field }) => (
                                    <div className="input-image ">
                                        <input ref={endDateRef} type="date" name='end_date' placeholder='End Date' required
                                            {...field}
                                            value={field.value}
                                            onChange={(e) => field.onChange(moment(e.target.value).format("YYYY-MM-DD"))}
                                        />
                                        <img src="/images/celender.png" alt="calendar Icon" className="custom-icon" />
                                    </div>
                                )} />
                        </div>
                        <div className="row-primary">
                            <h2>Vendor Site Code</h2>
                            <Controller
                                name="vendor_site_code"
                                control={control}
                                render={({ field }) => (
                                    <select className="input-in type_inp" {...field}>
                                        <option value="">All</option>
                                        <option value="ACH/C-ACH">ACH/C-ACH</option>
                                        <option value="A&A Language">A&amp;A Language</option>
                                        <option value="Paper Check">Paper Check</option>
                                    </select>
                                )} />
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div className="row-primary btns_area search_batns row_10 mb-0 border-bottom-0">
                            <SubmitButton btnText="Search" buttonType="submit" className={'green'} />
                            <SubmitButton buttonType="" className={'lightBlue'} btnText="Reset" onClick={handleResetFields} />
                        </div>
                    {checkPermission("Download Billing Report") && (
                        <button
                        type="button"
                        className="main_button"
                        onClick={() => handleDownloadReport()}
                        >
                        Download Full Report
                        </button>)}
                    </div>
                </form>
            </div>
        </div>
    );
}